import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import clsx from 'clsx';
import { CheckIcon, TimesIcon } from '../icon/solid';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  iconTimes: {
    color: palette.error.main,
  },
  iconCheck: {
    color: palette.secondary.main,
  },
}), { name: 'StatusIcon' });


type Props = {
  state: boolean;
  className?: string;
};

const StatusIcon = ({
  state,
  className,
}: Props) => {
  const classes = useStyles();

  if (state) {
    return <CheckIcon className={clsx(className, classes.iconCheck)} />;
  }

  return <TimesIcon className={clsx(className, classes.iconTimes)} />;
};

export default StatusIcon;
